import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { Sku } from '../../domain/entities/Sku';
import { StyledButton } from './ProductCTAStyles';
import { PREORDER_BUTTON, PREORDER_BUTTON_DISABLED } from '../../constants/DataTestIdAttributes';
import { buttonLabels } from '../../utils/ProductCTALabels';

export interface IPreorderButton {
    preorderAvailabilityLabel(preorderMessage: string): string;
    getStickyButtonLabel(buttonLabel: string): string;
    onPreorderButtonClick(): void;
    selectedSku: Sku;
    translations: ITranslationsCollection;
}

export const PreorderButton = translate(['availableOn'])(
    observer(function PreorderButton(props: IPreorderButton) {
        const {
            getStickyButtonLabel,
            onPreorderButtonClick,
            preorderAvailabilityLabel,
            selectedSku,
            translations
        } = props;
        const { isPreorderActive, isPreorderable, isShoppable, inventoryStatus } = selectedSku;
        const isPreorderDisabled = isPreorderable && !isShoppable;
        const { availableOn } = translations as ITranslationsCollection;
        const addToBagButtonLabels = buttonLabels(translations);

        const ctaButtonLabel = isPreorderDisabled
            ? preorderAvailabilityLabel(availableOn)
            : getStickyButtonLabel(addToBagButtonLabels[inventoryStatus]);

        const addToBagButtonClassNames = classnames({
            'elc-preorder-button': isPreorderActive,
            'js-preorder-button': isPreorderActive,
            'elc-preorder-button-disabled': isPreorderDisabled,
            'js-preorder-button-disabled': isPreorderDisabled
        });

        const addToBagButtonDataTestId =
            (isPreorderDisabled && PREORDER_BUTTON_DISABLED) ||
            (isPreorderActive && PREORDER_BUTTON);

        return (
            <StyledButton
                aria-label={ctaButtonLabel}
                className={addToBagButtonClassNames}
                data-test-id={addToBagButtonDataTestId}
                disabled={isPreorderDisabled}
                onClick={onPreorderButtonClick}
                title={ctaButtonLabel}
            >
                {ctaButtonLabel}
            </StyledButton>
        );
    })
);
